export default "__VITE_ASSET__DmvGuixJ__"